import BackgroundImage from "./background-image.png";

const styles = {
  loadingContainer: {
    backgroundImage: `url(${BackgroundImage})`,
  },
};

export default styles;
